function hideEditionButtonForOS() {
  const os = getOS();

  if (os.isAndroid || os.isLinux) {
    const viewEditionButton = document.getElementById('view-edition');
    if (viewEditionButton) {
      viewEditionButton.style.display = 'none';
    }
  }
}
